import React from 'react';
import { guides, steps } from '../data/kit';
export function Guides() {
  return <section className="bg-cream-50 px-4 py-8 md:py-16" data-id="element-112" data-mp="6lwafaur61mv">
      <div className="max-w-5xl mx-auto" data-id="element-113" data-mp="6mfi7yqov9n6">
        <div className="text-center mb-5 md:mb-10" data-id="element-114" data-mp="blin9j6o5fv5">
          <h2 className="font-serif text-[24px] md:text-[42px] font-bold text-wine tracking-tight leading-[1.12] max-w-3xl mx-auto" data-id="element-115" data-mp="bjxt3uo9nyxt">
            ASÍ PASÁS DE “NO SÉ QUÉ ME PASA”{' '}
            <span className="text-rose-600" data-id="element-116" data-mp="laac3igfnk1u">A SABER POR DÓNDE EMPEZAR</span>
          </h2>
          <ol className="flex flex-wrap justify-center items-center gap-x-1.5 sm:gap-x-2 gap-y-1 mt-3 md:mt-6 text-[13px] sm:text-sm font-semibold text-rose-700" data-id="element-117" data-mp="pbm6e1a94tgd">
            {steps.map((step, i) => <li key={step} className="flex items-center gap-1.5 sm:gap-2 whitespace-nowrap" data-id="element-118" data-mp="z9idmi02j497" data-mpi={i}>
                {i > 0 && <span className="text-ink-faint" aria-hidden="true" data-id="element-119" data-mp="2w4eq40nt0bmd">→</span>}
                <span data-id="element-120" data-mp="311epjsq5eg4i">{step}</span>
              </li>)}
          </ol>
        </div>

        <ol className="rounded-3xl bg-white border border-cream-300 divide-y divide-cream-300" data-id="element-121" data-mp="2tgszxji133sc">
          {guides.map((g, i) => <li key={g.title} className="grid grid-cols-[auto_1fr] md:grid-cols-[120px_1fr_1fr] gap-x-4 md:gap-x-5 gap-y-1 md:gap-y-2 px-4 py-4 md:p-7" data-id="element-122" data-mp="2oo9puwijuqsa" data-mpi={i}>
              <p className="font-serif text-rose-300 font-bold text-3xl md:text-5xl leading-none row-span-2 md:row-span-1" data-id="element-123" data-mp="2fqpjxa9qs6bc">
                {i + 1}
              </p>
              <div data-id="element-124" data-mp="37fsmmllzd8lv">
                <p className="text-[10px] md:text-[11px] font-bold tracking-[0.2em] text-rose-500" data-id="element-125" data-mp="37hlxkd3mmezo">
                  GUÍA {i + 1}
                </p>
                <h3 className="font-bold text-wine text-base md:text-lg leading-snug mt-0.5 md:mt-1" data-id="element-126" data-mp="2yfmgxlwixcx9">
                  {g.title}
                </h3>
                <p className="font-serif italic text-rose-700 text-[15px] md:text-base leading-snug mt-0.5 md:mt-1.5" data-id="element-127" data-mp="1s0boravv1rcj">
                  {g.subtitle}
                </p>
              </div>
              <p className="col-start-2 md:col-start-3 text-sm text-ink-muted leading-snug md:leading-relaxed" data-id="element-128" data-mp="1oio2rwxilpbx">
                {g.desc}
              </p>
            </li>)}
        </ol>
      </div>
    </section>;
}